<template lang="pug">
  .panel-page-white
    .panel-white.mx-auto
      ICEAlert
      PageHeader.mb-3 Receipt Transaction ID Lookup Results
      .d-flex.flex-row-reverse
        SearchBar.mb-3(v-model="filterText")
      .row
        .col
          Datatable(:entries="filterEntries" :column-count="8" :per-page="10")
            template(slot="header")
              th.h7 Person Summary
              th.h7
                div Transaction ID(s)
                div (N)PLEx
                div (S)tore
              th.h7 Transaction Date
              th.h7 Activity Type
              th.h7 Product(s)
              th.h7 Grams
              th.h7 Box(es)
              th.h7 Pharmacy
            template(slot-scope="props")
              tr
                td.body-3
                  router-link(:to="{name: 'person_summary', params: {id: props.entry.subjectSid}}") View Summary
                td.body-3
                  div (N) {{ props.entry.transactionSid }}
                  div (S) {{ props.entry.pharmacyTrxId }}
                td.body-3 {{ props.entry.transactionDt }}
                td.body-3 {{ props.entry.transactionCd }}
                td.body-3 {{ props.entry.productDesc.join(', ') }}
                td.body-3 {{ props.entry.grams }}
                td.body-3 {{ props.entry.boxes }}
                td.body-3
                  div {{ props.entry.pharmacyName }}
                  div {{ props.entry.phone }}
                  div {{ props.entry.pharmacyAddress1 }}
                  div {{ props.entry.pharmacyAddress2 }}
                  div {{ props.entry.pharmacyCity }}, {{ props.entry.pharmacyStateCd }} {{ props.entry.pharmacyPostalCode }}
</template>

<script>
import PageHeader from '@/components/PageHeader'
import SearchBar from '@/components/SearchBar'
import Datatable from '@/components/Datatable'
import { globalError } from '@/lib/utils'
import { formItem, clearForm } from '@/lib/formstore'
import axios from '@/lib/axios'

export default {
  name: 'TransactionResults',
  data: function() {
    return {
      filterText: '',
      entries: [],
    }
  },
  computed: {
    filterEntries: function() {
      if (this.filterText === '') return this.entries
      return this.entries.filter(entry => {
        let vals = Object.values(entry)
        return vals.some(
          val =>
            val &&
            val
              .toString()
              .toLowerCase()
              .includes(this.filterText.toLowerCase()),
        )
      })
    },
  },
  methods: {},
  async beforeRouteEnter(to, _from, next) {
    try {
      let results = await axios().get('/api/reports/link', {
        params: { id: to.params.id },
      })
      next(vm => (vm.entries = results.data.results))
    } catch (err) {
      globalError(err)
    }
  },
  beforeRouteLeave(_to, _from, next) {
    clearForm('transactionid')
    next()
  },
  components: {
    PageHeader,
    SearchBar,
    Datatable,
  },
}
</script>

<style lang="scss" scoped>
@import '../assets/styles/breakpoints';

.panel-white {
  width: 80%;

  @media (max-width: $bp-lg) {
    width: 100%;
  }
}
</style>
